<template>  
    <el-col :lg="24" class="px-2">
        <el-table
            ref="optionsTable"
            :data="options"
            row-key="id"
            :expand-row-keys="expandedRow"
            stripe
            style="width: 100%">
            <el-table-column type="expand">
                <template slot-scope="scope">
                    {{scope.row.description}}
                </template>
            </el-table-column>
            <el-table-column
                prop="name"
                label=""
                width="500">
                <template slot-scope="scope">
                    <el-radio-group class="d-block" v-model="option" @change="selectOption(scope.$index, scope.row)">
                        <el-radio
                            class="options mb-2 mx-0 ellipsis"
                            :key="scope.row.id"
                            :label="scope.row.id"
                            >{{scope.row.name}}
                        </el-radio>
                    </el-radio-group>
                </template>
            </el-table-column>
            <el-table-column
                prop="adult"
                label="Adulto">
            </el-table-column>
            <el-table-column
                prop="children"
                label="Niños">
            </el-table-column>
             <el-table-column
                prop="infant"
                label="Infantes">
            </el-table-column>
        </el-table> 
    </el-col>
</template>
<script>
    export default {
        props: ['options'],
        data() {
            return {
                expandedRow: [],
                option: '',
            };
        },
        methods: {
            selectOption(index, row){
                this.expandedRow = [];
                this.expandedRow.push(row.id);
                EventBus.$emit('select-option', this.option);
            },
            trans(value){
                if (!value) return '';
                return  _.get(window.i18n, value);
            },
        },
        filters: {
            translate: function (value) {
                if (!value) return '';
                return _.get(window.i18n, value);
            }
        },
        created() {
            EventBus.$on('listen-option', (new_option) => {
                this.option = new_option;
                this.expandedRow = [];
                this.expandedRow.push(new_option);
            });
        }
    };
</script>

<style type="text/css">
    .el-button--small {
        padding: 9px 15px!important;
    }
    .el-table tr {
        background-color: #e6e6e6;
    }
</style>